import { Column, Index, OneToMany } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';

/**
 * PD-14182 — Ownership grouping for clients. An ownership is a named owner /
 * holding group that several clients can belong to. It is a flat grouping
 * (clients point at a single ownership record), independent of the
 * self-referential parent/child hierarchy — a client can have both a parent
 * account and an ownership. Managed from the Clients page header menu, the
 * same way lifecycle stages are.
 */
@Index('unique_name', ['name', 'deletedDate'], {
	unique: true,
})
@Entity('ownership', {}, { label: 'Ownership' })
export class OwnershipEntity extends BaseEntity {
	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;

	@Column('varchar', { name: 'description', nullable: true, length: 500 })
	public description!: string | null;

	/**
	 * PD-13719 — unique, immutable identifier from the external system (e.g. the
	 * NetSuite chain/group internal id for Pharmsource). Populated by the Mover
	 * integration's ownership sync; null for ownerships created in SupplyMover.
	 */
	@Column('varchar', { name: 'externalId', nullable: true, length: 64 })
	public externalId!: string | null;

	@OneToMany(() => ClientEntity, (client) => client.ownership, {})
	public clients!: Array<ClientEntity>;
}
